import React from "react";

function MiddleArea1_2({ children }) {
  return <div>{children}</div>;
}

export default MiddleArea1_2;
